@if (order) {
  <div id="order-label-section">
    <h1>{{ 'ORDERS.TRANSACTION_ID' | translate }} - {{order.transactionId}}</h1>
    @if (order.reference) {
      <h2>{{ 'reference' | translate }}: {{order.reference}}</h2>
    }
    <table>
      <thead>
        <tr>
          <th>Produit</th>
          <th>Format</th>
          <th>Quantité</th>
          <th>Image</th>
        </tr>
      </thead>
      <tbody>
        @for (product of order.products; track product) {
          <tr>
            <td>{{product.productName}}</td>
            <td>{{product.dimension?.description }}</td>
            <td>{{product.quantity}}</td>
            <td><img [src]="productImages[product.poId]"></td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
